//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue'
import userTabs from '~/components/login/userTabs.vue'
import userCountry from '~/components/login/userCountry.vue'
import wikiGeet from '~/components/common/wikiGeet.vue'
import userVerificacode from '~/components/login/userVerificacode.vue'
import userVoicevercode from '~/components/login/userVoicevercode.vue'
import userThreparty from '~/components/login/userThreparty.vue'
import userGraphical from '~/components/login/userGraphical.vue'
import { assign } from '~/assets/js/utils.js'
export default {
  name: 'UserReset',
  components: {
    'user-header': userHeader,
    'user-tabs': userTabs,
    'user-country': userCountry,
    'wiki-geet': wikiGeet,
    'user-verificacode': userVerificacode,
    'user-threparty': userThreparty,
    'user-graphical': userGraphical,
    'user-voicevercode': userVoicevercode
  },
  data () {
    const voiceState = !this.$store?.state?.fullHost?.includes('wikifx')
    return {
      firstLoad: true, // 是否为首次加载该组件
      title: this.$t('22576'), // 头部标题
      tabs: [{ name: this.$t('22517'), type: 1 }, { name: this.$t('22577'), type: 2 }], // tab栏
      mobileNumber: 2, // 点击tab栏状态改变：1为手机验证码，2为电子邮箱/手机号
      verificationCode: 1, // 1为验证码，2为手机验证码
      // 验证码重置
      roTade: false, // 国家点击下拉框状态
      phoneSize: false, // 请输入手机号样式漂浮状态
      clearButton: false, // 清空
      phoneLoading: false, // 加载动画显示
      showDrag: false, // 是否展示极验拖拽框
      // 电子邮箱
      emailNumber: false, // 电子邮箱字样漂浮样式
      // 密码
      passwordState: false, // 密码字样漂浮样式
      confirmpasswordState: false, // 确认密码漂浮样式
      oneseyes: false, // 密码type
      twoseyes: false, // 确认密码type
      // 重置数值绑定
      resetin: {
        cellhoneNumber: '', // 重置手机号绑定
        mailorPhone: '', // 邮箱/手机号账号绑定
        formatError: '', // 手机号验证码登录错误提示
        setPassword: '', // 密码
        requestId: '', // 验证码requestid
        setconfirmPassword: '', // 确认密码
        errPassword: '', // 密码的错误提示
        smsCode: '', // 验证码
        emailphone: null // email为邮箱，phone为手机号
      },
      // 验证码
      voiceState, // 是否展示语音验证
      countOrnot: true, // 是否展示倒计时
      isVercode: false // 是否校验验证码
    }
  },
  computed: {
    // 完整的域名
    fullDomain () {
      return this.$store?.state?.fullHost
    },
    // 手机号相关信息（国旗、手机区号、手机号等）
    phoneCode () {
      return this.$store?.state?.phoneInfo || {}
    }
  },
  watch: {
    // 监听国家下拉框
    roTade (newV) {
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs?.userCountry?.getHeight()
      })
    },
    'resetin.cellhoneNumber': {
      handler (val) {
        if (val && this.mobileNumber == 1) this.clearButton = true
        else if (!val) {
          assign(this.resetin, { formatError: '' })
          this.clearButton = false
        }
      },
      immediate: true
    },
    'resetin.mailorPhone' (newV) {
      if (newV && this.mobileNumber == 2) this.clearButton = true
      else if (!newV) {
        assign(this.resetin, { formatError: '' })
        this.clearButton = false
      }
    },
    'resetin.setPassword' (newV) {
      if (newV && this.resetin.setconfirmPassword) this.clearButton = true
      else if (!newV) this.clearButton = false
    },
    'resetin.setconfirmPassword' (newV) {
      if (newV && this.resetin.setPassword) this.clearButton = true
      else if (!newV) this.clearButton = false
    },
    phoneCode () {
      assign(this.resetin, { formatError: '' })
    }
  },
  created () {
    this.mobileNumber = (this.fullDomain?.includes('wikifx') ? 2 : 1)
  },
  mounted () {
    document.addEventListener('click', this.coutryClose)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    // 语音获取验证码
    voiceVerification () {
      this.mobileNumber = 6 // 修改为语音验证码弹框
    },
    // 获取验证码
    getPhonecode (data = {}) {
      const { emailphone = '' } = this.resetin
      if (emailphone == 'phone') this.sendVCode(data)
      else if (emailphone == 'email') {
        this.sendEmail() // 发送邮箱验证码
        this.$refs?.userverificacode?.getSms() // 获取验证码
      }
    },
    // 极验错误
    geetError () {
      this.showDrag = false // 取消极验框状态
      this.mobileNumber = 5 // 出现图形验证码
    },
    // 点击非组件区域关闭下拉框
    coutryClose (e = {}) {
      if (!this.$el.contains(e?.target)) this.roTade = false
    },
    // 语音获取验证码
    voiceTran () {
      this.countOrnot = false // 展示获取验证码
      this.mobileNumber = 4 // 修改为验证码弹框
      this.verificationCode = 2 // 修改为语音验证码获取
      this.$nextTick(() => {
        this.$refs?.userverificacode?.getweebgeet() // 调用极验
      })
    },
    // 语音获取取消
    voiceClose () {
      this.countOrnot = false // 取消倒计时
      this.mobileNumber = 4 // 跳转为验证码
    },
    // tab栏切换
    switstat (i = 1) {
      assign(this.resetin, { cellhoneNumber: '', mailorPhone: '', setPassword: '', formatError: '' }) // 手机号验证码登录绑定清空，错误提示绑定清空，邮箱账号绑定清空
      this.phoneLoading = this.phoneSize = this.emailNumber = this.showDrag = false // 请输入手机号样式状态false，电子邮件或手机号样式状态false，电子邮件或手机号密码样式状态false
      this.mobileNumber = i // 显示状态：1为手机验证码，2为手机号/邮箱登录
      if (i == 2) this.voiceState = false // tab栏为邮箱时则取消语音获取验证码
      this.roTade = false
    },
    // 清除按钮
    close () {
      assign(this.resetin, { cellhoneNumber: '', formatError: '' }) // 手机输入内容为空/手机错误提示为空/邮箱为空
      this.phoneSize = this.phoneLoading = false // 请输入手机号样式为false，加载动画为false
    },
    // 下一步/登录
    logoIn () {
      const { cellhoneNumber = '', setPassword = '', setconfirmPassword = '' } = this.resetin
      if (this.mobileNumber == 1 && cellhoneNumber) { // 等于1是手机号验证码
        assign(this.resetin, { emailphone: 'phone' })
        this.getVercode() // 获取验证码
      } else if (this.mobileNumber == 3 && setPassword && setconfirmPassword) {
        if (setPassword != setconfirmPassword) return (this.resetin.errPassword = this.$t('22578'))
        if (setconfirmPassword?.length < 6 || setconfirmPassword?.length > 20) return (this.resetin.errPassword = this.$t('22563'))
        assign(this.resetin, { errPassword: '' })
        this.resetPassword() // 重置密码
      } else if (this.mobileNumber == 2) { // 邮箱校验
        assign(this.resetin, { emailphone: 'email' })
        this.numberRis() // 校验邮箱
      }
    },
    // 校验是否注册
    async numberRis () {
      const { cellhoneNumber = '', mailorPhone = '' } = this.resetin
      if (this.phoneLoading) return false // 接口请求中，不执行后续操作
      if (this.mobileNumber == 1) {
        if (!cellhoneNumber) return false
        this.phoneLoading = true // 请求开始
        try {
          const { succeed = false, extra = '', result = {} } = await this.$api.login.userCheckphone({ areaCode: this.phoneCode?.code, phoneNumber: cellhoneNumber }) // 校验手机号是否注册
          console.log('这里22')
          this.phoneLoading = false // 请求结束
          if (!succeed) return (this.resetin.formatError = extra) // 数据错误
          if (!result.isregister) return (this.resetin.formatError = this.$t('22579'))
          this.showDrag = true
        } catch (err) {}
      } else if (this.mobileNumber == 2) {
        if (!mailorPhone) return false
        this.phoneLoading = true // 请求开始
        try {
          const { succeed = false, extra = '', result = {} } = await this.$api.login.userMailregis({ email: mailorPhone, languageCode: this.currLangCode() }) // 校验邮箱是否注册
          this.phoneLoading = false // 请求结束
          if (!succeed) return this.$toast.error(extra) // 数据错误
          if (!result) return (this.resetin.formatError = this.$t('22580'))
          this.sendEmail() // 发送邮箱验证码
        } catch (err) {}
      }
      this.phoneLoading = false // 请求结束
    },
    // 发送验证码
    getVercode () {
      const { cellhoneNumber = '' } = this.resetin
      if (!cellhoneNumber) return (this.resetin.formatError = this.$t('22520'))
      const myreg = this.phoneCode?.code != '0086' ? /^.{5,20}$/ : /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (myreg.test(cellhoneNumber)) {
        assign(this.resetin, { formatError: '' }) // 验证成功则错误消息清空
        this.numberRis() // 校验手机号
      } else assign(this.resetin, { formatError: this.$t('22521') })
    },
    // 验证码成功之后登录
    async getUsertion (code = '') {
      const { emailphone = '', cellhoneNumber = '', mailorPhone = '' } = this.resetin
      if (emailphone == 'phone') {
        try {
          const { succeed = false, extra = '' } = await this.$api.login.userVerifysms({ AreaCode: this.phoneCode?.code, PhoneNumber: cellhoneNumber, Smscode: code, ApplicationType: 7, ValidateSmsCodeType: 3, LanguageCode: this.currLangCode() })
          if (!succeed) return this.$toast.error(extra) // 数据错误
          assign(this.resetin, { smsCode: code }) // 验证码赋值
          this.mobileNumber = 3 // 切换为密码框
        } catch (err) {}
      } else if (emailphone == 'email') {
        try {
          const { succeed = false, extra = '', result = {} } = await this.$api.login.userVerifymail({ Email: mailorPhone, Code: code, ApplicationType: 7, CountryCode: this.phoneCode?.countryCode, LanguageCode: this.currLangCode() })
          if (!succeed) return this.$toast.error(extra) // 数据错误
          assign(this.resetin, { requestId: result?.requestId, smsCode: code }) // 验证码赋值
          this.mobileNumber = 3 // 切换为密码框
        } catch (err) {}
      }
    },
    // 验证码成功后重置密码
    async resetPassword () {
      const { setconfirmPassword = '', requestId = '', emailphone = '', mailorPhone = '', cellhoneNumber = '' } = this.resetin
      if (this.phoneLoading) return false // 接口请求中，不执行后续操作
      this.phoneLoading = true // 请求开始
      try {
        const { succeed = false, extra = '' } = await this.$api.login.userChangePassword({ npwd: setconfirmPassword, requestId, languageCode: this.currLangCode(), userId: '', email: emailphone == 'email' ? mailorPhone : '', areaCode: this.phoneCode?.code, phone: emailphone == 'phone' ? cellhoneNumber : '' }) // 修改密码
        this.phoneLoading = false // 请求结束
        if (!succeed) return (this.resetin.errPassword = extra) // 数据错误
        assign(this.resetin, { cellhoneNumber: '', mailorPhone: '', setPassword: '', formatError: '' }) // 手机号验证码登录绑定清空，错误提示绑定清空，邮箱账号绑定清空
        this.$emit('loginSwitch', 1)
      } catch (err) {}
      this.phoneLoading = false // 请求结束
    },
    // 发送邮箱验证码
    async sendEmail () {
      const { mailorPhone = '' } = this.resetin
      if (!mailorPhone) return false
      try {
        const { succeed = false, extra = '' } = await this.$api.login.userMailcode({ email: mailorPhone, languageCode: this.currLangCode(), emailType: 0, applicationType: 7, version: 124 })
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.mobileNumber = 4
      } catch (err) {}
    },
    // 验证码登录极验
    async sendVCode (data = {}) {
      this.showDrag = false
      const { cellhoneNumber = '' } = this.resetin
      if (!cellhoneNumber) return false
      try {
        console.log(333333, '1/2')
        // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.phoneCode?.code, phone: cellhoneNumber, languageCode: this.currLangCode(), msgType: this.verificationCode == 1 ? 0 : 1, smsBusinessType: 1, applicationType: 7, GeetestValidate: data.geetest_validate, GeetestChallenge: data.geetest_challenge }) // 发送验证码
        // if (!succeed) return this.$toast.error(extra) // 数据错误
        // assign(this.resetin, { requestId: result?.requestid })
        // this.verificationCode = 1 // 修改为验证码获取
        // this.mobileNumber = 4

        const res = await this.$api.common
          .v3Client(
            {
              Routes: 'usercenter$sendcodegeettest4'
            },
            {
              areaCode: this.phoneCode?.code,
              phone: cellhoneNumber,
              languageCode: this.currLangCode(),
              msgType: (this.verificationCode == 1 ? 0 : 1),
              userId: this.userId,
              smsBusinessType: 1,
              applicationType: 7,
              GeetestValidate: data.geetest_validate,
              GeetestChallenge: data.geetest_challenge,
              captcha_output: data.captcha_output,
              lot_number: data.lot_number,
              pass_token: data.pass_token,
              gen_time: data.gen_time
            }
          )
          .catch(() => {
            console.log('sendcodegeettest4')
          })

        const rest = res?.usercenter?.sendcodegeettest4
        console.log('rest::: ', rest)
        if (rest?.success) {
          assign(this.resetin, { requestId: rest?.requestid })
          this.verificationCode = 1 // 修改为验证码获取
          this.mobileNumber = 4
        } else {
          return this.$toast.error(rest?.extra || 'error')
        }
      } catch (err) {}
    },
    // 图形验证成功后发送验证码
    async setVercode (data = '') {
      this.showDrag = false
      const { cellhoneNumber = '' } = this.resetin
      if (!cellhoneNumber) return false
      try {
        console.log(444444, '1/2')
        // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: this.phoneCode?.code, phone: cellhoneNumber, languageCode: this.currLangCode(), msgType: 0, smsBusinessType: 1, applicationType: 7, GeetestValidate: '', GeetestChallenge: '', graphCode: data }) // 发送验证码
        // if (!succeed) return this.$toast.error(extra) // 数据错误
        // assign(this.resetin, { requestId: result?.requestid })
        // this.mobileNumber = 4

        const res = await this.$api.common
          .v3Client(
            {
              Routes: 'usercenter$sendcodegeettest4'
            },
            {
              areaCode: this.phoneCode?.code,
              phone: cellhoneNumber,
              languageCode: this.currLangCode(),
              msgType: 0,
              userId: this.userId,
              smsBusinessType: 1,
              applicationType: 7,
              GeetestValidate: data.geetest_validate,
              GeetestChallenge: data.geetest_challenge,
              captcha_output: data.captcha_output,
              lot_number: data.lot_number,
              pass_token: data.pass_token,
              gen_time: data.gen_time
            }
          )
          .catch(() => {
            console.log('sendcodegeettest4')
          })

        const rest = res?.usercenter?.sendcodegeettest4
        console.log('rest::: ', rest)
        if (rest?.success) {
          assign(this.resetin, { requestId: rest?.requestid })
          this.mobileNumber = 4
        } else {
          return this.$toast.error(rest?.extra || 'error')
        }
      } catch (err) {}
    }
  }
}
